export const TITLE_POSTFIX = '- Bolt'
